/**
 * Hides the FOUC page loader after fonts/DOM are ready, with a hard timeout
 * so accessibility is never blocked indefinitely.
 */
(function () {
  const MAX_WAIT_MS = 4000;
  const FADE_MS = 450;
  let hidden = false;

  function hideLoader() {
    if (hidden) return;
    hidden = true;

    const el = document.getElementById('viperia-page-loader');
    if (!el) return;

    el.classList.add('is-hidden');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('aria-busy', 'false');

    setTimeout(() => {
      if (el.parentNode) el.parentNode.removeChild(el);
      document.documentElement.classList.remove('viperia-loading');
    }, FADE_MS + 50);
  }

  function whenFontsReady() {
    if (document.fonts && document.fonts.ready) {
      return document.fonts.ready.catch(function () {});
    }
    return Promise.resolve();
  }

  function ready() {
    const domReady =
      document.readyState === 'interactive' || document.readyState === 'complete'
        ? Promise.resolve()
        : new Promise(function (resolve) {
            document.addEventListener('DOMContentLoaded', resolve, { once: true });
          });

    Promise.all([domReady, whenFontsReady()]).then(function () {
      // Allow one paint after fonts/DOM settle
      requestAnimationFrame(function () {
        requestAnimationFrame(hideLoader);
      });
    });
  }

  ready();
  window.addEventListener('load', hideLoader, { once: true });
  setTimeout(hideLoader, MAX_WAIT_MS);
})();
